import React from 'react';
import Link from 'next/link';

import Button from '@mui/material/Button';
import { SxProps, Theme } from '@mui/system';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { CategoryProps } from '../utils/types';

const buttonStyles = (
  isHighlighted: boolean = false,
  type: Pick<CategoryProps, 'type'>['type'] = 'category'
): SxProps<Theme> => ({
  fontSize: '15px',
  fontWeight: 500,
  lineHeight: '26px',
  letterSpacing: '0.46px',
  color: isHighlighted ? 'red' : 'rgba(0, 0, 0, 0.87)',
  padding: '8px 11px',
  height: '42px',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'space-between',
  textTransform: 'none',
  '&:active': {
    backgroundColor: 'rgba(116, 155, 141, 0.08)',
  },
  ...(type === 'title' && { fontWeight: 'bold' }),
});

const TopMenuMobileLink = ({
  href,
  onMouseEnter,
  showRightIcon,
  label,
  component,
  handleOnClick,
  isHighlighted = false,
  type = 'category',
}: CategoryProps) => {
  const isLink = Boolean(href);
  const ComponentToRender = component || (isLink ? Link : 'button');

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (!isLink) {
      e.preventDefault();
      if (handleOnClick) {
        handleOnClick?.(e);
      }
    }
  };

  return (
    <Button
      disableRipple
      variant="text"
      onClick={handleClick}
      component={ComponentToRender}
      {...(isLink ? { href } : {})}
      onMouseEnter={onMouseEnter}
      sx={buttonStyles(isHighlighted, type)}
    >
      <span
        style={{
          WebkitLineClamp: 1 /* number of lines to show */,
          overflow: 'hidden',
          display: '-webkit-box',
          textOverflow: 'ellipsis',
          WebkitBoxOrient: 'vertical',
        }}
      >
        {label}
      </span>
      {showRightIcon && <ChevronRightIcon sx={{ color: isHighlighted ? 'red' : 'rgba(0, 0, 0, 0.87)' }} />}
    </Button>
  );
};

export default TopMenuMobileLink;
